export default __webpack_public_path__ + "static/media/resume_templates.e3364baa.png";